<div class="flex flex-fill flex-col flex-gap-standard page-border">
  <app-page-panel
  [showBackButton]="false" 
  iconNameFontAwesome="device_reset" 
  pageTitle="Verlauf" 
  [showBackColor]="true"
  [showDetailsButton]="false"
  [showSidepanelButton]="false"
  (iconMenuButtonClicked)="navigationService.toggleSidepanelHistory()">
      <dx-data-grid #gridVerlauf 
          [allowColumnResizing]="true"
          [rowAlternationEnabled]="true"
          [allowColumnReordering]="true"
          [hoverStateEnabled]="true"
          noDataText=""
          [dataSource]="dataVerlauf()"
          (onContentReady)="onContentReady($event)"
          [height]="'calc(100vh - 200px)'">
          <dxo-selection mode="single"></dxo-selection>
          <dxi-column dataField="datum" caption="Datum" [width]="110" alignment="left" [dataType]="'date'" format="dd.MM.yyyy" sortOrder="desc"></dxi-column>
          <dxi-column dataField="aktion" caption="Aktion" alignment="left" allowSorting="false"></dxi-column>
          <dxi-column dataField="vonStufe" caption="Von Stufe" alignment="left"></dxi-column>
          <dxi-column dataField="anStufe" caption="An Stufe" alignment="left"></dxi-column>
          <dxi-column dataField="user" caption="Änderer" alignment="left"></dxi-column>
          <dxo-master-detail [enabled]="false" template="detail"></dxo-master-detail>
            <div *dxTemplate="let verlauf of 'detail'">
              <div class="flex flex-col flex-fit">
                <div class="anmerkung">{{verlauf.data?.anmerkung}}</div>
                @if (verlauf.data?.dateiNameAnhang) {
                  <div class="flex flex-row flex-fit flex-justify-start flex-center">
                    <div class="flex flex-fit file-drop backcolor-plangebiet-ALLE-light">Anhang: {{verlauf.data?.dateiNameAnhang}}</div>
                    <button [disabled]="!verlauf.data?.dateiNameAnhang" type="button" mat-icon-button (click)="onFileShowButtonClick(verlauf.data)" title="Datei anzeigen">
                        <mat-icon>open_in_new</mat-icon>
                    </button>                            
                  </div>
                }
              </div>  
            </div> 
      </dx-data-grid>
  </app-page-panel>
</div>